<int-integrators-details
        [integrationName]="integrationName"
        [integrationType]="integrationType"
        [creating]="creating"
        [user]="user"
        [invites]="invites"></int-integrators-details>

<div mat-dialog-content>
    <span *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" [diameter]="35"></mat-progress-spinner>
    </span>

    <div *ngIf="creating && !editing" class="int-text-container">
        {{description}}
    </div>

    <div *ngIf="isAdmin && invites.length > 0">
        <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
    </div>

    <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
        <button mat-stroked-button color="primary" (click)="addAnother($event)">
            <mat-icon>add</mat-icon>
            <span class="center-text">ADD ANOTHER ACCOUNT</span>
        </button>
    </div>

    <div *ngIf="!noAccounts && !creating">
        <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
            <mat-icon>expand_more</mat-icon>
            <span>SHOW CONNECTED ACCOUNTS</span>
        </button>
        <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
            <mat-icon>expand_less</mat-icon>
            <span>HIDE CONNECTED ACCOUNTS</span>
        </button>
    </div>

    <div *ngIf="!creating" [hidden]="!showAccounts">
        <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
        <div *ngFor="let int of existingIntegrations">Drive Name: {{ int.friendlyName }}</div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center" style="margin-bottom: 3%">
        <div (click)="onClick()" *ngIf="creating && !editing" class="google-btn">
            <div class="google-icon-wrapper">
                <img class="google-icon-svg" src="../../assets/image/google-signin-btn.svg" />
            </div>
            <p class="btn-text"><b>Sign in with Google</b></p>
        </div>
    </div>

    <form #driveForm="ngForm">
        <div *ngIf="editing && drives">
            <mat-form-field>
                <input
                        matInput
                        #name="ngModel"
                        placeholder="Destination Name"
                        [(ngModel)]="createdIntegration.friendlyName"
                        name="name"
                        required
                />
            </mat-form-field>
        </div>
        <div *ngIf="editing && drives">
            <mat-form-field *ngIf="drives.length > 0">
                <mat-select
                    #driveId="ngModel"
                    placeholder="Select a Drive"
                    [(ngModel)]="selectedDrive"
                    name="driveId"
                    required
                >
                    <mat-option *ngFor="let drive of drives" [value]="drive">{{ drive.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <span class="text-block" *ngIf="editing && drives && drives.length === 0 && !loading">
            No shared drives found. Authenticate with a different Google account or we will use your personal drive.
        </span>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
        <button mat-button mat-dialog-close>CANCEL</button>
        <button
                *ngIf="!loading && editing"
                [appShowSpinner]="submitLoading"
                buttonText="SAVE"
                mat-raised-button
                color="primary"
                [disabled]="!driveForm.form.valid"
                (click)="update()"
        ></button>
    </div>
</div>